import { ArrowRightIcon } from '@motorway/mw-highway-code';
import { Hyperlink, VRM } from '@motorway/mw-highway-code/alpha';
import { THCComponentProps } from '@THC/types';
import { filterDataProps } from '@THC/utils/helpers';

import { POST_SALE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsPostSale';

import vehicleImagePlaceHolder from 'Containers/app/vehicleCollection/assets/vehicleImagePlaceholder.svg';
import { useSaleDetailsSub } from 'Containers/app/vehicleCollection/hooks/useSaleDetailsSub';
import { useVehicleCollectionSub } from 'Containers/app/vehicleCollection/hooks/useVehicleCollectionSub';

import styles from './VehicleCard.module.scss';

type VehicleCardProps = THCComponentProps<{}>

type VehicleCardContentProps = {
  imageUrl: string;
  make: string;
  model: string;
  vrm?: string;
}

const useVehicleCard = () => {
  const { vehicle } = useVehicleCollectionSub();
  const { make, model, vehicleProfilePath, vehicleThumbnail } = useSaleDetailsSub();

  return {
    href: vehicleProfilePath,
    imageUrl: vehicleThumbnail,
    make,
    model,
    vrm: vehicle?.vrm_pretty,
  };
};

const VehicleCardContent = ({
  imageUrl,
  make,
  model,
  vrm,
}: VehicleCardContentProps) => (
  <>
    <div className={styles.thumbnail}>
      <img alt="Car image" className={styles.vehicleImage} src={imageUrl || vehicleImagePlaceHolder} />
    </div>
    <div className={styles.details}>
      {vrm && <VRM size='xsmall' text={vrm} />}
      {make && model && (<p className={styles.makeModel}>{make} {model}</p>)}
    </div>
    <span className={styles.chevron}>
      <ArrowRightIcon size="xsmall" />
    </span>
  </>
);

export const VehicleCardView = (props: ReturnType<typeof useVehicleCard>) => {
  const { href, ...cardProps } = props;
  const dataProps = filterDataProps(props);

  return (
    <div className={styles.vehicleCard}>
      <Hyperlink
        {...dataProps}
        data-thc-hyperlink
        aria-label='View vehicle profile'
        href={href}
        label={<VehicleCardContent {...cardProps} />}
        onClick={() => POST_SALE_SNOW_PLOW_EVENTS.VIEW_VEHICLE_PROFILE()}
        target='_blank'
        underline={false}
      />
    </div>
  );
};

export const VehicleCard = (props: VehicleCardProps) => {
  const dataProps = filterDataProps(props);

  return (
    <VehicleCardView {...useVehicleCard()} {...dataProps}/>
  );
};
